module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark A. Tietjen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Mark A. Tietjen is Associate Professor of Philosophy and Religion at the University of West Georgia. ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dvpzw/tc-custom/9780253008718.jpg?1717895558243",
      "alt": "This image is the cover for the book Kierkegaard, Communication, and Virtue"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kierkegaard, Communication, and Virtue\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Tietjen offers the kind of approach that encourages us to put the emphasis where it rightly belongs: on Kierkegaard’s philosophical ideas.” —"), _c('i', [_vm._v("Notre Dame Philosophical Reviews")])]), _c('br'), _c('br'), _vm._v("In contrast to recent postmodern and deconstructionist readings, Mark A. Tietjen believes that the purpose behind Kierkegaard’s writings is the moral and religious improvement of the reader. Tietjen defends Kierkegaard against claims that certain features of his works, such as pseudonymity, indirect communication, irony, and satire are self-deceived or deceitful. "), _c('i', [_vm._v("Kierkegaard, Communication, and Virtue")]), _vm._v(" reveals how they are directly related to the virtues or moral issues being discussed. In fact, Tietjen argues, the manner of presentation is a critical element of the philosophical message being conveyed. Reading broadly in Kierkegaard’s writings, he develops a hermeneutics of trust that fully illustrates Kierkegaard’s aim to evoke faith in his reader."), _c('br'), _c('br'), _c('b', [_vm._v("“Tietjen’s critique of deconstructionist readings of Kierkegaard along with an emphasis on employing a hermeneutic of trust clearly distinguishes his work from other treatments of Kierkegaard as a virtue ethicist and edifying writer.” —Sylvia Walsh, Stetson University")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0